module.exports = __webpack_public_path__ + "static/ms-icon-144x144-184ffff5feb3eae25d97a6d95899128f.png";